import React from 'react'

import { AccountProviderConfigurationFragment } from 'generated/resources/graphql'

export const ProviderConfigurationContext = React.createContext<{
  configuration: AccountProviderConfigurationFragment | null | undefined
}>({ configuration: null })
